import { toast } from "react-toastify";
import { takeEvery, call, put, select } from "redux-saga/effects";

import {
  deleteCustomerAddress,
  getCustomerDetail,
  patchCustomerDetail,
  postCustomerAddress,
  putCustomerAddress,
  putCustomerPassword,
} from "@/services/CustomerService";

import Customer from "@/redux/models/Customer";
import { getApiFirstErrorMessage } from "@/utils/getApiErrorMessage";
import { trackAddShippingInfo } from "@/utils/googleTag";
import Order from "@/redux/models/Order";

const {
  update,
  retrieveCustomerDetail,
  addLocation,
  updateLocation,
  updateCustomerDetail,
  updatePassword,
  deleteLocation,
} = Customer.types;

function* getCustomerDetailSaga(action) {
  try {
    const cb = action.payload?.cb;
    const { id, ...user } = yield call(getCustomerDetail);

    yield put(update({ ...user, customer_id: id }));

    if (cb) cb(user);
  } catch (err) {
    toast.error(getApiFirstErrorMessage(err));
  }
}

function* updateCustomerDetailSaga(action) {
  try {
    const { payload } = action;
    yield call(patchCustomerDetail, {
      ...payload,
      phone: payload.phone || null,
    });
    const state = yield select();
    const user = state.Customer.itemsById[0];
    yield put(
      update({
        ...user,
        ...payload,
      })
    );

    toast.success("Account Updated");
  } catch (err) {
    toast.error(getApiFirstErrorMessage(err));
  }
}

function* addLocationSaga(action) {
  try {
    const { cb, location } = action.payload;
    const customer = yield select(Customer.selectors.getCustomer);
    const order = yield select(Order.selectors.getOrder);
    const resp = yield call(postCustomerAddress, location);

    yield put(update({ locations: resp }));

    if (order?.id) trackAddShippingInfo(order, customer);

    if (cb) cb(resp[0]);
  } catch (err) {
    toast.error(err?.message || "Something went wrong!");
  }
}

function* updateLocationSaga(action) {
  try {
    const { cb, location } = action.payload;
    const resp = yield call(putCustomerAddress, location, location?.id);

    toast.success("Address Updated");

    yield put(update({ locations: resp }));

    if (cb) cb(resp.find((loc) => loc.id === location.id));
  } catch (err) {
    toast.error(err?.message || "Something went wrong!");
  }
}

function* updatePasswordSaga(action) {
  try {
    const { payload } = action;
    yield call(putCustomerPassword, payload);

    toast.success("Password Updated");
  } catch (err) {
    toast.error(err?.message || "Something went wrong!");
  }
}

function* deleteLocationSaga(action) {
  try {
    const { cb, location } = action.payload;

    const newLocations = yield call(deleteCustomerAddress, location.id);

    const selectedLocation = newLocations.find((l) => l.default) || newLocations[0];

    yield put(update({ locations: newLocations }));

    if (cb) cb(selectedLocation);

    toast.success("Address Deleted");
  } catch (err) {
    toast.error(err.message || "Something went wrong!");
  }
}

export default function* watchApp() {
  yield takeEvery(updateCustomerDetail().type, updateCustomerDetailSaga);
  yield takeEvery(retrieveCustomerDetail().type, getCustomerDetailSaga);
  yield takeEvery(addLocation().type, addLocationSaga);
  yield takeEvery(updateLocation().type, updateLocationSaga);
  yield takeEvery(updatePassword().type, updatePasswordSaga);
  yield takeEvery(deleteLocation().type, deleteLocationSaga);
}
